export default __webpack_public_path__ + "static/media/Transition_Start-Deployment.f1066285.mp4";